import { FileTypeRadPdf } from "@/ExportableFile/Models/FileTypes/FileTypeRadPdf";
import { PatientForms } from "../Models/Forms/RadPdf/Forms";
import { PdfFormInboxItem } from "../Models/ShareItems/PdfFormInboxItem";

class RadPdfExportableFileHelper {
    public static fromPatientForm(patientForm: PatientForms, viewedFromEncounterId: string = ""): FileTypeRadPdf {
        return new FileTypeRadPdf({
            patientFormId: patientForm.Id,
            versioningEncounterId: viewedFromEncounterId,
            description: patientForm.FormName,
            date: patientForm.CreationDate,
            formId: patientForm.FormId
        });
    }

    public static fromPdfFormInboxItem(pdfFormInboxItem: PdfFormInboxItem): FileTypeRadPdf {
        return new FileTypeRadPdf({
            patientFormId: pdfFormInboxItem.Id,
            versioningEncounterId: pdfFormInboxItem.ViewedFromEncounterId,
            description: pdfFormInboxItem.FormName,
            date: pdfFormInboxItem.CreationDate,
            formId: pdfFormInboxItem.FormId
        });
    }
}

export { RadPdfExportableFileHelper };
